import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import SchedulePage from "@/pages/schedule/page";
import MatchPage from "@/pages/match/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news-detail/page";
import AboutPage from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:league", element: <CategoryPage /> },
      { path: "schedule", element: <SchedulePage /> },
      { path: "match/:matchId", element: <MatchPage /> },
      { path: "news", element: <NewsPage /> },
      { path: "news/:newsId", element: <NewsDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;